import { render, staticRenderFns } from "./ms-add-drug.vue?vue&type=template&id=24c49016&scoped=true"
import script from "./ms-add-drug.vue?vue&type=script&lang=js"
export * from "./ms-add-drug.vue?vue&type=script&lang=js"
import style1 from "./ms-add-drug.vue?vue&type=style&index=1&id=24c49016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c49016",
  null
  
)

export default component.exports